// 图标枚举

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// 根据图标名获取图标实例
export const getInstance = (iconName) => {
    if (!iconName) {
        return iconEnum['menu'] || iconEnum['grid']
    }

    // 兼容两种写法：
    // Element Plus 原始组件名：DocumentCopy / TrendCharts / DataAnalysis
    // 路由里常用的 kebab 写法：document-copy / trend-charts / data-analysis
    const firstLowerName = toLowerCaseFirstLetter(iconName)
    const camelName = kebabToCamel(firstLowerName)

    return iconEnum[firstLowerName] || iconEnum[camelName] || iconEnum['menu'] || iconEnum['grid']
}

// 图标枚举
let iconEnum = {}

/**
 * 初始化枚举
 */
export const initEnum = () => {

    let data = {}

    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
        let itemKey = toLowerCaseFirstLetter(key)
        data = {
            ...data,
            [itemKey]: component
        }
    }
    iconEnum = data
}

// 首字母小写
const toLowerCaseFirstLetter = (str) => {
    if (!str || typeof str !== 'string' || str.length === 0) {
        return str;
    }
    return str.charAt(0).toLowerCase() + str.slice(1);
}

// kebab-case 转 camelCase，例如 document-copy => documentCopy
const kebabToCamel = (str) => {
    if (!str || typeof str !== 'string') {
        return str
    }
    return str.replace(/-([a-zA-Z])/g, (_, letter) => letter.toUpperCase())
}
